export const fileTypesEnum = {
  LOG: 'LOG',
  DATA_PARSED: 'DATA_PARSED',
  DATA_MBUS: 'DATA_MBUS',
  SYSTEM: 'SYSTEM',
  UNKNOWN: 'UNKNOWN',
} as const

export type FileTypesEnum = (typeof fileTypesEnum)[keyof typeof fileTypesEnum]

export type FileTypes = FileTypesEnum